import React from 'react';
import {
  PoliciesLinksListContainer,
  PolicyLink,
} from './PoliciesLinksList.styles';

const PoliciesLinksList = (): JSX.Element => {
  return (
    <PoliciesLinksListContainer className='policies-links-list-container'>
      <PolicyLink
        className='policy-link'
        href='/privacy-policy'
      >
        PRIVACY POLICY
      </PolicyLink>
      <PolicyLink
        className='policy-link'
        href='/terms-of-use'
      >
        TERMS OF USE
      </PolicyLink>
      <PolicyLink
        className='policy-link'
        target='_blank'
        rel='noreferrer noopener'
        href='https://trust.mightynetworks.com/'
      >
        SECURITY & TRUST REPORT
      </PolicyLink>
    </PoliciesLinksListContainer>
  );
};

export default PoliciesLinksList;
